import { aksaraAdminApiSource } from '@/projects/aksara/datasource/adminApiSource';
import type { User } from '@/models/model.type';

export const aksaraAdminAuthRepository = {
  login: (googleToken: string) => aksaraAdminApiSource.login(googleToken),

  async profile(token: string): Promise<User> {
    const profile = await aksaraAdminApiSource.profile(token);
    return {
      id: profile.id,
      email: profile.email,
      fullName: profile.name,
      role: profile.roles.includes('ADMIN') ? 'admin' : 'user',
      roles: profile.roles,
      avatarUrl: null,
      createdAt: new Date(0),
      isActive: true,
    };
  },
};
